<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="typeList.id"
          field-name="id"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="typeList.category"
          field-name="category"
          source-type="type-list-categories"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="typeList.name"
          field-name="name"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="typeList.name_mask"
          field-name="name_mask"
          rules="required"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="typeList.parameters"
          field-name="parameters"
          rules=""
          type="text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditTypeList',
    props: {
      typeList: Object,
    },
  }
</script>
